module.exports = __webpack_public_path__ + "static/media/not-editable-cursor.75a35f0b.svg";